import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    promotionsList: null,
    promotionsAmount: 0,
};

export const promotionsSlice = createSlice({
    name: 'promotions',
    initialState,
    reducers: {
        setPromotionsList(state, action) {
            state.promotionsList = action.payload;
        },
        setPromotionsAmount(state, action) {
            state.promotionsAmount = action.payload;
        },
    },
});
export const { setPromotionsList, setPromotionsAmount } = promotionsSlice.actions;
